import { render, staticRenderFns } from "./MilitaryStatusTypeInfo.vue?vue&type=template&id=16e32a0c&"
import script from "./MilitaryStatusTypeInfo.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports